import { defineMessages } from 'react-intl';

export default defineMessages({
    expirationDate: {
        id: 'platform.paymentdetails.credit-card-auto-details.Expiration Date',
        defaultMessage: 'Expiration Date',
    },
});
